import { useDomainStore } from "@/store/domain-store";
import { ServerApiAccess } from "../server-api-access";

export default class GetTalksTask {
  public static async run(domainId: string): Promise<void> {
    try {
      const access = new ServerApiAccess();
      const talks = await access.getTalks(domainId);
      await useDomainStore().setTalks(talks);
    } catch (error) {
      console.error("get-talks error:%O", error);
    }
  }
}
